import { IDateRangeGState } from "../../interfaces/datesGlobalState.interface";
import { Action } from "@leap4/frontend";
import { ActionsTypes } from "../consts/actionsTypes";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../config/generals";

const url: URL = new URL(window.location.href);
const params: URLSearchParams = url.searchParams;
const sd = params.get("startDate") || dayjs().subtract(0, "day").format(DATE_FORMAT);
const ed = params.get("endDate") || dayjs().subtract(0, "day").format(DATE_FORMAT);

if (!window.location.pathname.includes('/login')) {
    window.history.replaceState(null, null, window.location.pathname);
}

const initialState: IDateRangeGState = {
    startDate: sd,
    endDate: ed,
    isLoading: {
        isLoadingGeneral: false,
    },
    isLoadingAny: false,
};

function isLoadingAny(obj: any) {
    return Object.values(obj).some(x => !!x);
}

export const DateRangeReducer = function (state: IDateRangeGState = initialState, action: Action) {
    const { type, payload } = action;
    switch (type) {
        case ActionsTypes.SET_TIME_RANGE:
            return {
                ...state,
                startDate: payload.startDate,
                endDate: payload.endDate,
            };
        case ActionsTypes.SET_IS_LOADING:
            const obj = {
                ...state.isLoading,
                ...payload.isLoading,
            };
            return {
                ...state,
                isLoading: obj,
                isLoadingAny: isLoadingAny(obj),
            };
        default:
            return state;
    }
};
